import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Footer = () => {
  const { user } = useAuth();
  const privacyPath = user ? '/dashboard?tab=privacy' : '/privacy-policy';
  const termsPath = user ? '/dashboard?tab=terms' : '/terms-of-service';

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>© {new Date().getFullYear()} PromptCRM.ai</div>
        <div className="footer-links">
          <Link to={privacyPath}>Privacy Policy</Link>
          <Link to={termsPath}>Terms of Service</Link>
          <a href="mailto:support@animaticmedia.com">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
